import { render, staticRenderFns } from "./app-main.vue?vue&type=template&id=18dc76b3&scoped=true&"
import script from "./app-main.vue?vue&type=script&lang=ts&"
export * from "./app-main.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18dc76b3",
  null
  
)

export default component.exports